import {setSystemToLowercase} from './shared/serverFunctions';
import Config from './messages';

/**
 * VIP Card Configurations
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "LoyaltyRanks": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Loyalty Ranks",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyRanks/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Loyalty Rank",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyRank/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let loyaltyRanksParams = populateLoyaltyRanksParams(params);
            return {
                "type": "upsert",
                "data": loyaltyRanksParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLoyaltyRank"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let loyaltyRanksParams = populateLoyaltyRanksParams(params);
            return {
                "type": "upsert",
                "data": loyaltyRanksParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLoyaltyRank"
            }
        },
    },
    "LoyaltyIncentiveTiers": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Loyalty Incentive Tiers",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyIncentiveTiers/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            params.min_dollars = params.id;
            return {
                "type": "item",
                "method": "GET",
                "title": "Loyalty Incentive Tier",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyIncentiveTier/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLoyaltyIncentiveTier"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLoyaltyIncentiveTier"
            }
        },
    },
    "VipCardConfigurations": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            params.sort.field = 'prefix';
            params.sort.order = 'ASC';
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Card Configurations",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/allLoyaltyCardConfigs/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            params.prefix = params.id;
            return {
                "type": "item",
                "method": "GET",
                "title": "VIP Card Configuration",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyCardConfig/" + system + "/" + params.prefix
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let vipCardConfigParams = populateVipCardConfigParams(params);
            return {
                "type": "upsert",
                "data": vipCardConfigParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/createLoyaltyCardConfig"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let vipCardConfigParams = populateVipCardConfigParams(params);
            return {
                "type": "upsert",
                "data": vipCardConfigParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/editLoyaltyCardConfig"
            }
        },
    },
    "LoyaltyAccounts": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            const paramSet = getLoyaltyAccountParamFromFilter(params);
            let endpoint = '';
            switch (paramSet.param) {
                case 'id':
                    endpoint = "getLoyaltyCustomerById/";
                    break;
                case 'email':
                    endpoint = "getLoyaltyCustomerByEmail/";
                    break;
                case 'telephone':
                    endpoint = "getLoyaltyCustomerByTelephone/";
                    break;
                default:
                    endpoint = "getLoyaltyCustomerById/";
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Loyalty Accounts",
                "uri": localStorage.getItem('server') + "/api/v5/admin/" + endpoint + system + "/" + paramSet.value
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            const mode = localStorage.getItem('mode');
            return {
                "type": "item",
                "method": "GET",
                "title": "Loyalty Account",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LoyaltyDomainManager/lookupById/" + system + "/" + params.id + "/" + mode
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let loyaltyAccountParams = populateLoyaltyAccountParams(params, true);
            return {
                "type": "upsert",
                "data": loyaltyAccountParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertLoyaltyAccount"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let loyaltyAccountParams = populateLoyaltyAccountParams(params, false);
            return {
                "type": "upsert",
                "data": loyaltyAccountParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/admin/upsertLoyaltyAccount/" + params.data.system
            }
        },
    },
    "LoyaltyAccountIdAvailable": {
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Checking Loyalty Id Availability",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/isAvailableLoyaltyId/" + system + "/" + params.id
            }
        },
    },
    "CustomerLedgerEntries": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            const mode = localStorage.getItem('mode');
            let accountId = params.filter.account_id;
            if (accountId) {
                params.account_id = accountId;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Customer Ledger Entries",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/LoyaltyDomainManager/customerLedgerEntries/" + system + "/" + params.account_id + "/" + mode
            }
        },
    },
    "LoyaltyAccountTags": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let accountId = params.filter.account_id;
            return {
                "type": "list",
                "method": "GET",
                "title": "Customer Tags",
                "uri": localStorage.getItem('server') + "/api/v5/admin/tags/" + system + "/" + accountId
            }
        },
    },
    "LoyaltyAccountTransactions": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Loyalty Account Transactions",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyFraudLogsByCustomer/" + system + "/" + params.customer + "?params=" + JSON.stringify(params)
            }
        },
    },
    "LoyaltyAccountLogs": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            const typeParam = getLoyaltyAccountLockTypeFilter(params);
            let typeValue = (typeParam) ? "/" + typeParam : '';
            return {
                "type": "list",
                "method": "GET",
                "title": "Loyalty Account Logs by Fraud/Temp",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/loyaltyFraudLogsByType/" + system + typeValue + "?params=" + JSON.stringify(params)
            }
        },
    },
};

/*
 * Convert range values for VIP Card Configurations
 */
const populateVipCardConfigParams = (params) => {
    // Populate required fields
    params.data.range_start = parseInt(params.data.range_start_string, 10);
    params.data.range_end = parseInt(params.data.range_end_string, 10);

    // Remove unused form objects
    delete params.data.range_start_string;
    delete params.data.range_end_string;

    return params;
};

/**
 * Get a Loyalty Account parameter (id, email, telephone) from text input
 *
 * @param params
 * @return {null}
 */
const getLoyaltyAccountParamFromFilter = (params) => {
    if (!params.filter) {
        return null;
    }
    const paramSet = {param: '', value: ''};
    const loyalty_id = (params.filter.loyalty_id) ? params.filter.loyalty_id : null;
    const loyalty_email = (params.filter.loyalty_email) ? params.filter.loyalty_email : null;
    const loyalty_telephone = (params.filter.loyalty_telephone) ? params.filter.loyalty_telephone : null;
    // Set parameter and value from filter
    if (loyalty_id) {
        paramSet.param = 'id';
        paramSet.value = loyalty_id;
    } else if (loyalty_email) {
        paramSet.param = 'email';
        paramSet.value = loyalty_email;
    } else if (loyalty_telephone) {
        paramSet.param = 'telephone';
        paramSet.value = loyalty_telephone;
    }
    return paramSet;
};

/*
 * Populate values for Loyalty Accounts
 */
const populateLoyaltyAccountParams = (params, is_creating = false) => {

    const system = setSystemToLowercase();

    params.data.reward_points = parseFloat(params.data.reward_points);
    params.data.rank_points = parseFloat(params.data.rank_points);

    // Populate required fields
    params.data.system = system;
    params.data.mode = localStorage.getItem('mode');

    params.data.is_creating = is_creating;
    params.data.email = params.data.email ? params.data.email.toLowerCase() : null;
    if (is_creating) {
        // Add Client data and remove unused fields from Create form
        params.data.registered_by_client = {
            system: system,
            location: Config.fuse.client.location,
            register: Config.fuse.client.register,
            user: localStorage.getItem('email'),
            device: Config.fuse.client.device,
            version: Config.fuse.admin.version
        };

        delete params.data.prefix_select;
        delete params.data.id_string;
    } else {
        if (!params.data.email || params.data.email === '' ) {
            params.data.email = null;
        }

        // Remove unused fields from Edit form
        delete params.data.customer;
        delete params.data.rank;
        delete params.data.current_rank_points;
        delete params.data.current_reward_points;
    }

    let firstName = (params.data.first_name) ? params.data.first_name.replace(/\s\s+/g, ' ').trim() : '';
    let lastName = (params.data.last_name) ? params.data.last_name.replace(/\s\s+/g, ' ').trim() : '';
    params.data.first_name = firstName;
    params.data.last_name = lastName;

    return params;
};

const populateLoyaltyRanksParams = (params) => {
    params.data.rank_point_days_valid = params.data.reward_point_days_valid;
    return params;
};

const getLoyaltyAccountLockTypeFilter = (params) => {
    if (!params.filter) {
        return null;
    }
    const loyalty_lock = (params.filter.loyalty_lock) ? params.filter.loyalty_lock : null;
    if (loyalty_lock) {
        return loyalty_lock;
    }
    return null;
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "VipCardConfigurations"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseLoyaltyResourceMap.js